<template>
  <div>
    <vue-slider v-model="values" :tooltip="'none'" :dotSize="16" :height="6" :min="0" :max="filter.max"
      @drag-end="dragEnd" @click.native="dragEnd" direction="rtl" />

    <div class="range-slider-values">
      <div>
        {{ values[0] | commaSeparator }}
      </div>

      <div>
        {{ values[1] | commaSeparator }}
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";


export default {
  name: "FilterItemRange",

  props: ["filter"],

  components: {
    VueSlider,
  },

  data() {
    return {
      values: [
        0,
        this.filter.selectedValues[1]
      ]
    };
  },

  methods: {
    ...mapActions(["onChangeFilter"]),

    dragEnd() {

      this.onChangeFilter({
        filterItem: null,
        filter: {
          id: this.filter.id,
          title: this.filter.title,
          type: this.filter.type,
          selectedValues: this.values
        }
      });

    },
  },

  filters: {
    commaSeparator(value) {
      if (!value) {
        return 0;
      }
      value = Number(value).toFixed(0);
      value = Intl.NumberFormat().format(value);
      return value;
    },
  },
};
</script>
